
import { defineComponent, ref, watch, onUnmounted, onMounted } from 'vue';
import LayerOverlay from '@/components/LayerOverlay.vue';
import Layer from '@/components/Layer.vue';
import Star from '@/components/Star.vue';

export default defineComponent({
  name: 'App',
  components: {
    LayerOverlay, Layer,
    Star
  },
  setup() {
    const star = ref(null);
    const hidden = ref(false);
    const hide = () => hidden.value = !hidden.value;

    const framesPerSecond$ = ref(null); // Observable<number>
    let fpsSubscription = null;
    const fpsCount = ref(0);
    // framesPerSecond$ puede establecerse múltiples veces, al ocultarse y visualizarse de nuevo el componente hijo que asigna el valor
    watch(framesPerSecond$, (fps$, prevFps$) => {
        if(fpsSubscription !== null) {
            fpsSubscription.unsubscribe();
        }
        fpsSubscription = fps$.subscribe(fps => fpsCount.value = fps);
    });

    onUnmounted(() => {
        if (fpsSubscription) {
            fpsSubscription.unsubscribe();
            fpsSubscription = null;
        }
    });

    const onCanvasDimension = (dimension) => {
      console.log(`*** Dimension: (${dimension.width}, ${dimension.height})`);
    }

    const active = ref(true);
    const inputEnabled = ref(true);
    // const mainLayerEnabled = ref(true);

    const quicker = () => {
      const newPace = star.value.engineCurrentPace() + 0.1;
      star.value.paceEngine(newPace);
    };

    const slower = () => {
      const newPace = star.value.engineCurrentPace() - 0.1;
      star.value.paceEngine(newPace);
    };

    const pause = () => {
      star.value.pauseEngine();
      active.value = false;
    };

    const sleep = () => {
      star.value.sleepEngine();
      active.value = false;
    };

    const resume = () => {
      star.value.resumeEngine();
      active.value = true;
    };

    const enableInput = () => {
      star.value.enableInput();
      inputEnabled.value = true;
    };

    const disableInput = () => {
      star.value.disableInput();
      inputEnabled.value = false;
    };

    const enableBackgroundLayer = () => {
      star.value.enableBackgroundLayer();
    }

    const disableBackgroundLayer = () => {
      star.value.disableBackgroundLayer();
    }

    const backgroundLayerEnabled = () => {
      return star.value && star.value.backgroundLayerEnabled();
    };

    const enableMainLayer = () => {
      star.value.enableMainLayer();
    }

    const disableMainLayer = () => {
      star.value.disableMainLayer();
    }

    const mainLayerEnabled = () => {
      return star.value && star.value.mainLayerEnabled();
    };

    return {
      star, // componente hijo
      hidden, hide,
      framesPerSecond$, fpsCount,
      onCanvasDimension,
      quicker, slower,
      pause, sleep, resume, active,
      enableInput, disableInput, inputEnabled,
      enableBackgroundLayer, disableBackgroundLayer, backgroundLayerEnabled,
      enableMainLayer, disableMainLayer, mainLayerEnabled
    };
  }
});
